/**
 * 系統常數。
 */
/** JWT 設定 */
export const JWT_ISSUER = 'bom-system';
export const JWT_ACCESS_TOKEN_TTL_SECONDS = 24 * 60 * 60; // 24h
/** 主账号（受保护）：不可删除 / 停用 / 取消平台管理员。全小写比对。 */
export const PRIMARY_ADMIN_EMAIL = 'admin@cruise-cloud.com';
/** 密碼策略 */
export const PASSWORD_MIN_LENGTH = 8;
export const BCRYPT_COST_FACTOR = 12;
export const LOGIN_FAILURE_LOCK_THRESHOLD = 5;
export const LOGIN_FAILURE_LOCK_MINUTES = 15;
/** JWT 公钥缓存 TTL（jwt-authorizer 用） */
export const JWT_PUBLIC_KEY_CACHE_TTL_MS = 60 * 60_000; // 1 小時
//# sourceMappingURL=constants.js.map